<h2 class="user-banner-header" [id]="headingId || null">
  <fa-icon [icon]="faUserSolid" class="person-icon" aria-hidden="true"></fa-icon>
  @if (showDoubleIcon) {
    <fa-icon [icon]="faUserSolid" class="person-icon" aria-hidden="true"></fa-icon>
  }
  <span>Messages for {{ title }}. {{ forename }} {{ surname }}</span>
  @if (showCollapseButton) {
    <button
      class="collapse-arrow-btn"
      (click)="onCollapseClick()"
      aria-label="Collapse messages for {{ forename }} {{ surname }}"
    >
      <i class="ico-left-open" aria-hidden="true"></i>
    </button>
  }
</h2>
